<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla"
      :resource="resource"
      @_funcionExtra="getObtenerDatosBandeja"
      @_funcionExtra2="abrirModalMotivo"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente>

    <!--  Modal motivo   -->
    <b-modal
        ref="motivo"
        title="Motivo de rechazo del PTI"
        hide-footer
    >
      <br />
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.motivoRechazo }}</h4>
      <br />
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal()"
      >Cerrar</b-button
      >
      <br /><br/>
    </b-modal>
  </div>
</template>

<script>
import BandejaComponente from "../../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "BandejaHallazgoRechazados",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    fechaFin: "",
    fechaIncio: "",
    idPaciente: 0,
    datosTabla: [],
    encabezadosPendientes: [
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "motivoRechazo",
        label: "Motivo de rechazo del PTI",
        sortable: true,
        component: "BandejaMotivoRechazoComponente"
        
      },
      {
        key: "cambiarEstatusIncompletos",
        label: "Cambiar a estatus Incompletos",
        sortable: true,
        component: "BandejaCambiarEstatusIncompletosComponente", 
      },
    ],
    encabezadosEnproceso: [
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "motivoRechazo",
        label: "Motivo de rechazo del PTI",
        sortable: true,
        component: "BandejaMotivoRechazoComponente"
        
      }, 
      {
        key: "regresarPendiente",
        label: "Regresar estatus ",
        sortable: true,
        component: "BandejaRegresarEstatusPendienteComponente", 
      },
      {
        key: "cambiarEstatusIncompletos",
        label: "Cambiar a estatus Incompletos",
        sortable: true,
        component: "BandejaCambiarEstatusIncompletosComponente", 
      },
    ],
    encabezadosFinalizados: [
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "dtefechaModificacion",
        label: "Fecha de salida",
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "motivoRechazo",
        label: "Motivo de rechazo del PTI",
        sortable: true,
        component: "BandejaMotivoRechazoComponente"
        
      }, 
    ],
    encabezadosIncompletos: [
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Presentador PTI Presuntivo",
        sortable: true,
      },
      {
        key: "motivoRechazo",
        label: "Motivo de rechazo del PTI",
        sortable: true,
        component: "BandejaMotivoRechazoComponente"
        
      }, 
      {
        key: "regresarPendiente",
        label: "Regresar estatus ",
        sortable: true,
        component: "BandejaRegresarEstatusPendienteComponente", 
      },
    ],
    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_pend",
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_proces",
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_fin",
      },
      {
        id: 6,
        nombre: "Incompletos",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_incomp",
      },
    ],
    icono: "fa fa-credit-card",
    titulo: "CENTRO DE DIAGNÓSTICO",
    codigoTitulo: "DX_",
    subTitulo: "Bandeja de Rechazos PTI",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    },
    idEstatusPestañaSeleccionada : 1,
    solicitud: null
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      let tomaHerramientas = true;
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;

      if (intIdEstuatusSolicitud === 4){
        tomaHerramientas = false;
      }


      this.$http
        .get(
          this.$api +
            "hallazgo/bandeja/obtenerDatosBandeja/rechazados?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&intIdEstuatusSolicitud=" +
            intIdEstuatusSolicitud +
            "&idPaciente=" +
            this.idPaciente+
            "&tomaHerramientas=" +
            tomaHerramientas
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.permiteCambiarDiagnosticador =
            response.data.data.blnPermiteEditar;
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
          this.datosTabla = response.data.data.listaResultados;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        });
 
    },
    getCifrasPorEstatus() {
      this.showAlert();

      this.cifrasControl[1].layoutTabla = this.encabezadosEnproceso;
      this.cifrasControl[0].layoutTabla = this.encabezadosPendientes;
      this.cifrasControl[2].layoutTabla = this.encabezadosFinalizados;
      this.cifrasControl[3].layoutTabla = this.encabezadosIncompletos;

      this.cifrasControl.forEach(c => c.cantidad = 0)
      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/cifrasPorEstatus/rechazados", params )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
              }
              if (elemento.idEstatusSolicitud == 6) {
                this.cifrasControl[3].cantidad = elemento.noTotalSolcitudes;
              }
            });
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });
    }, //  ----------------------------

    getObtenerEncargadosClinica() {
      this.showAlert();
      const parametros = {idClinica: this.idClinica}
      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/obtenerEncargadosClinica", parametros
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray

          if (Array.isArray(response.data.data) == true) {
            this.resource.arrayDiagnosticadores = response.data.data;
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getObtenerDatosBandeja(1);
        });
    },
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },


      showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

    abrirModalMotivo(data) {
      this.solicitud = data;
      this.$refs["motivo"].show();
    },

    cerrarModal(){
      this.solicitud = null;
      this.$refs["motivo"].hide();
    }



  },
  mounted() {
    this.getObtenerEncargadosClinica(); 
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    var dia1 = new Date();
    dia1.setHours(0, 0, 0, 0);
    dia1.setDate(dia1.getDate() - 1);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
